import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ocorrenciaForm';
import Select from '../common/form/select';

import { setModoTela, initForm, buscarImagens, salvar, excluir, getLista, getListaMotorista, getListaVeiculo } from './ocorrenciaActions';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';

class Ocorrencia extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		status: 1
	}

    componentWillMount() {
		this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
    }

    render() {
        return (
            <div>

				<Aguardando aguardando={this.props.aguardando} />

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								disabled={this.props.permissoes.acesso_despesa != 2}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ 
										datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										id_motorista: this.props.sessao && this.props.sessao.id_motorista ? this.props.sessao.id_motorista : null
									});
								}} />
						</Grid>
					</Row>
					<Row style={{ marginTop: 8 }}>
						<Select
							label='Status'
							cols='12 6 4 3'
							options={[{ id: '1', valor: 'Aberta' }, { id: '2', valor: 'Finalizada' }, { id: '3', valor: 'Ambas' }]}
							value={this.state.status}
							onChange={item => {
								this.setState({ ...this.state, status: item })
							}} />
					</Row>					
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						
							<Tr>
								<Th>Data Hora</Th>
								<Th>Motorista</Th>
								<Th>Placa</Th>
								<Th>Descrição Motorista</Th>
								<Th>Descrição Gerente</Th>
								<Th alignCenter>Status</Th>
								<Th></Th>
							</Tr>
						
						<TBody>
							{this.props.lista.filter(item => 
								this.props.sessao && (!this.props.sessao.id_motorista || this.props.sessao.id_motorista == item.id_motorista)
								).filter(item => {
									if (this.state.status != 3 && ((this.state.status == 1 && (item.id_ordem_servico || item.resolvido)) || (this.state.status == 2 && !(item.id_ordem_servico || item.resolvido)))) {
										return false;
									}
									if (this.state.pesquisar
										&& !(`${item.nome_motorista} ${item.placa_carreta} ${item.descricao}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
										return false;
									}
									return true;
								}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)}</Td>
									<Td>{item.nome_motorista}</Td>
									<Td>{item.placa_carreta}</Td>
									<Td>{item.descricao}</Td>
									<Td>{item.descricao_gerente}</Td>
									<Td alignCenter>{item.id_ordem_servico ? 'OS' : (item.resolvido ? 'Resolvido' : 'Aberto')}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={this.props.permissoes.acesso_despesa != 2}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)
												});
												this.props.initForm({
													...item,
													datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)
												});
												this.props.buscarImagens(item.id);
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={this.props.permissoes.acesso_despesa != 2}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)
												});
												this.props.initForm({
													...item,
													datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)
												});
												this.props.buscarImagens(item.id);
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.ocorrencia.modoTela,
	aguardando: state.ocorrencia.aguardando,
	lista: state.ocorrencia.lista,
	permissoes: state.usuario.permissoes
});
const mapDispatchToProps = dispatch => bindActionCreators({setModoTela, initForm, buscarImagens, salvar, excluir, getLista, getListaMotorista, getListaVeiculo }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Ocorrencia);
